import { useContext } from "react"
import { toAbsoluteUrl } from "../../../utils/assetHelper"
import "./style.scss"
import { AuthContext } from "../../../context/auth"
import Cookies from "js-cookie"
import { useMixPanel } from "../../../hooks/useMixPanel"
import { useGtag } from "../../../hooks/useGtag"
const Index = () => {
    const { setOpenPopupModal } = useContext(AuthContext)
    const { mixPanelEvent, mixPanelServerEvent } = useMixPanel()
    const { gtagViewDownloadEvent } = useGtag()
  return (
    <div className="small-modal-wrapper">
          <div className='popup-modal-content'>
            <span className='close' onClick={() => {
                setOpenPopupModal(false)
                Cookies.set('popupSeen', 'true', { expires: 14 })
            }}><i className="fas fa-times"></i></span>
            <div className="img-container">
              <img src={toAbsoluteUrl('/media/popupimg.png')} alt="storm calibration" />
            </div>
            <div className="text-container">
          <h3>Identifyn® SRM Alexa Fluor™ Direct Conjugates now Available at Thermo Fisher</h3>
                <div className="link-container"
                onClick={() => {
                const data = {
                  thermo_link: 'https://www.thermofisher.com/antibody/product/gamma-H2AX-SRM-Antibody-clone-BLR014M-Recombinant-Monoclonal/DC000003'
                  }
                  mixPanelEvent('thermo', data)
                  mixPanelServerEvent('thermo', data)
                  gtagViewDownloadEvent('thermo', data)
                }}
                >
                <a href="https://www.thermofisher.com/antibody/product/gamma-H2AX-SRM-Antibody-clone-BLR014M-Recombinant-Monoclonal/DC000003" target="_blank"><img src={toAbsoluteUrl('/media/thermologo.png')} alt="thermofisher" width={'148px'} /></a>
                <a href="https://www.thermofisher.com/antibody/product/gamma-H2AX-SRM-Antibody-clone-BLR014M-Recombinant-Monoclonal/DC000003" target="_blank"><em>Click here to see our products</em></a>
                </div>
          <p>Identifyn® SRM Alexa Fluor™ Direct Conjugates excel across all resolutions and applications, offering a variety of options from 405 to 750nm.</p>
            </div>
          </div>
    </div>
  )
}

export default Index